/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * scrollTrigger-parallax.js
 *
 * スクロールに合わせて実行するパララックスアニメーション用
 *
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * 初期設定
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const parallaxMainVisual = document.querySelectorAll(".parallax-main");

/**
 * set
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
gsap.set(parallaxMainVisual, {
  yPercent: 15,
});

/**
 * パララックス - img
 * スクロールに合わせて実行するパララックス
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
const setParallaxMainVisual = () => {
  gsap.registerEffect({
    name: "parallaxMainVisual",
    effect: (targets, config) => {
      return gsap.to(targets, {
        yPercent: -5,
        scrollTrigger: {
          trigger: targets,
          start: "-50% center",
          end: "150% center",
          scrub: 0.5,
          // markers: true,
        },
      });
    },
  });

  document.querySelectorAll(".parallax-main").forEach(function (point) {
    gsap.effects.parallaxMainVisual(point);
  });
};

/**
 *  Export.
 */
/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
export { setParallaxMainVisual };